import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapMutations } from 'vuex';
import { SET_BACK_BUTTON_EVENT, SET_NAV_CALLBACK } from '$mutations';
export default {
  data: function data() {
    return {};
  },
  watch: {},
  methods: _objectSpread({}, mapMutations([SET_BACK_BUTTON_EVENT, SET_NAV_CALLBACK])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.backFun) {
        if (vm.SET_BACK_BUTTON_EVENT) {
          vm.SET_BACK_BUTTON_EVENT(vm.backFun);
        }

        if (vm.SET_NAV_CALLBACK) {
          vm.SET_NAV_CALLBACK({
            backFun: vm.backFun
          });
        }
      }
    });
  },
  mounted: function mounted() {
    this.SET_BACK_BUTTON_EVENT(this.backFun);
    this.SET_NAV_CALLBACK({
      backFun: this.backFun
    });
  }
};